import { render, staticRenderFns } from "./lucky_pet.vue?vue&type=template&id=ed49977a&"
import script from "./lucky_pet.vue?vue&type=script&lang=js&"
export * from "./lucky_pet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports